<template>
  <ul v-if="questions && questions.length">
    <li
      v-for="item in questions"
      class="questions-list ma-0 mb-3 pa-0"
      cols="12"
      :key="item.id"
    >
      <div class="subtitle-1 font-weight-bold d-flex align-center">
        <ScreeningQuestionIcon
          class="mr-1"
          :type="item.type"
          :small="true"
        /> {{ item.body }}
      </div>
      <ul
        v-if="item.answerOptions"
        class="answer-options-list body-2 mt-1"
      >
        <li
          v-for="(answer, index) in item.answerOptions"
          class="mb-1"
          :key="index"
        >
          {{ answer.body }}
        </li>
      </ul>
    </li>
  </ul>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import ScreeningQuestionIcon from '@/components/screeningQuestions/ScreeningQuestionIcon.vue'
import { IApplicationAnswer } from '@/types/models/application.model'
import { IScreeningQuestion } from '@/types/models/screeningQuestion.model'

@Component({
  components: {
    ScreeningQuestionIcon
  }
})
export default class ScreeningQuestionsList extends Vue {
  @Prop({ required: true, default: [] }) questions: IScreeningQuestion[]

}
</script>
<style lang="scss" scoped>
.questions-list {
  list-style-type: decimal;
}
</style>
